import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { Instrument } from '../../Models/Domains/Investment/Instrument';
import { InstrumentSearchQuery } from '../../Models/Domains/Investment/InstrumentSearchQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class InstrumentSearchQueryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: InstrumentSearchQuery, hierarchyId: string): Promise<ResultPageModel<Instrument>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/InstrumentSearchQuery/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query, hierarchyId: hierarchyId }

    return AjaxWrapper.post<ResultPageModel<Instrument>, any>(url, data);
  }
}

